module.exports = __webpack_public_path__ + "img/service-added.7d0730b2.png";